import {qspost, qspostfile} from '@/plugins/axios'

/*
 * 获取数据报表-小区 - 各月
 * @constructor jack
 * */
export const getShuJuBiaoMingXi = (year, xiangmu_id, xiaoqu_id) => qspost('/Index/Xinxuqiu/getShuJuBiaoMingXi', {
  year,
  xiangmu_id,
  xiaoqu_id
})


/*
 * 获取项目下小区 当月收入/支出数据
 * @constructor jack
 * */
export const getOneMonthMingXi = (xiangmu_id, xiaoqu_id, year, month, type) => qspost('/Index/Xinxuqiu/getOneMonthMingXi', {
  xiangmu_id,
  xiaoqu_id,
  year,
  month,
  type
})

/*
 * 更新项目下小区 当月收入/支出数据
 * @constructor jack
 * */
export const addMingXi = (xiangmu_id, xiaoqu_id, year, month, type, value) => qspost('/Index/Xinxuqiu/addMingXi', {
  xiangmu_id,
  xiaoqu_id,
  year,
  month,
  type,
  value
})


/*
 * 获取数据报表- 汇总
 * @constructor jack
 * */
export const getShuJuBiao = (year, xiangmu_id, xiaoqu_id) => qspost('/Index/Xinxuqiu/getShuJuBiao', {
  year,
  xiangmu_id,
  xiaoqu_id
})

/*
 * 创建或更新全年应收/全年应付
 * @constructor jack
 * */
export const addQuanNianYingShouFu = (xiangmu_id, xiaoqu_id, year, type, value) => qspost('/Index/Xinxuqiu/addQuanNianYingShouFu', {
  xiangmu_id,
  xiaoqu_id,
  year,
  type,
  value
})


/*
 * 创建或更新核定收入/核定支出
 * @constructor jack
 * */
export const addQuanNianHeDingShouFu = (xiangmu_id, xiaoqu_id, year, type, value) => qspost('/Index/Xinxuqiu/addQuanNianHeDingShouFu', {
  xiangmu_id,
  xiaoqu_id,
  year,
  type,
  value
})


/*
 * 汇总导出
 * @constructor jack
 * */
export const exportShuJuBiao = (xiangmu_id, xiaoqu_id, year) => qspostfile('/Index/Export/exportShuJuBiao', {
  xiangmu_id,
  xiaoqu_id,
  year,
})


/*
 * 汇总导出
 * @constructor jack
 * */
export const addQuanNianBeiZhu = (xiangmu_id, xiaoqu_id, year,id,  value) => qspost('/Index/Xinxuqiu/addQuanNianBeiZhu', {
  xiangmu_id,
  xiaoqu_id,
  year,
  id,
  value
})

